/* Gift answers stay in the page. Prices and availability come from Shopify Liquid. */
(() => {
  if (window.ByardsGiftFinder) return;
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-gift-finder]').forEach((root) => {
      if (root.dataset.finderReady) return;
      const form = root.querySelector('[data-finder-form]');
      const status = root.querySelector('[data-finder-status]');
      let data;
      try {
        data = JSON.parse(root.querySelector('[data-finder-data]').content.textContent);
        if (!Array.isArray(data.products) || !Array.isArray(data.groups)) throw new Error('Missing gift data');
      } catch (_) {
        status.textContent = 'Please explore the gift collections below.';
        return;
      }
      root.dataset.finderReady = 'true';
      if (!data.products.length) {
        status.textContent = 'Explore the collections below for our current gift selection.';
        return;
      }
      const groups = new Map(data.groups.map((group) => [group.id, group]));
      const products = Array.from(new Map(data.products.map((product) => [product.id, product])).values());
      const results = root.querySelector('[data-finder-results]');
      const grid = root.querySelector('[data-finder-grid]');
      const empty = root.querySelector('[data-finder-empty]');
      const links = root.querySelector('[data-finder-links]');
      const heading = root.querySelector('[data-finder-heading]');
      const element = (tag, className, text) => {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined) node.textContent = text;
        return node;
      };
      const safeUrl = (value) => {
        try {
          const url = new URL(value, location.origin);
          return url.origin === location.origin && url.protocol === location.protocol ? url.href : null;
        } catch (_) { return null; }
      };
      form.hidden = false;
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const interest = form.elements.interest.value;
        const occasion = form.elements.occasion.value;
        const budget = form.elements.budget.value ? Number(form.elements.budget.value) : Infinity;
        const selected = [interest, occasion].filter(Boolean);
        const matches = products.filter((product) =>
          Number.isFinite(product.price) && product.price <= budget && safeUrl(product.url) &&
          Array.isArray(product.groups) && selected.every((id) => product.groups.includes(id))
        );
        const shortlist = matches.slice(0, 6);
        grid.replaceChildren();
        links.replaceChildren();
        shortlist.forEach((product) => {
          const card = element('li', 'b-gift-finder__card');
          const link = element('a');
          link.href = safeUrl(product.url);
          const media = element('div', 'b-gift-finder__media');
          if (product.image) {
            const image = element('img');
            image.src = product.image;
            image.alt = product.alt || product.title;
            image.width = 480;
            image.height = 640;
            image.loading = 'lazy';
            image.decoding = 'async';
            image.addEventListener('error', () => {
              media.replaceChildren(element('span', 'b-gift-finder__placeholder', 'View product details'));
            }, { once:true });
            media.append(image);
          } else {
            media.append(element('span', 'b-gift-finder__placeholder', 'View product details'));
          }
          const reasons = selected.length ? selected.map((id) => groups.get(id)?.reason).filter(Boolean) :
            [groups.get(product.groups.find((id) => groups.get(id)?.type === 'interest') || product.groups[0])?.reason].filter(Boolean);
          link.append(media,
            element('h4', 'b-gift-finder__product-title', product.title),
            element('p', 'b-gift-finder__price', `${product.varies ? 'From ' : ''}${product.priceText}`),
            element('p', 'b-gift-finder__reason', reasons.join(' ')),
            element('span', 'b-gift-finder__view', 'View details ↗')
          );
          card.append(link);
          grid.append(card);
        });
        const browseGroups = selected.length ? selected.map((id) => groups.get(id)) :
          data.groups.filter((group) => group.type === 'source');
        browseGroups.forEach((group) => {
          if (!group || !safeUrl(group.url)) return;
          const link = element('a', '', `Explore the full collection: ${group.label} ↗`);
          link.href = safeUrl(group.url);
          links.append(link);
        });
        empty.hidden = shortlist.length > 0;
        grid.hidden = shortlist.length === 0;
        results.hidden = false;
        status.textContent = shortlist.length ? `${shortlist.length} ${shortlist.length === 1 ? 'idea matches' : 'ideas match'} your choices in this selection.${matches.length > 6 ? ' Here are six to start with.' : ''}` : 'No matches in this selection for all of your choices.';
        heading.textContent = shortlist.length ? 'Your shortlist' : 'Let’s widen the search';
        heading.focus({ preventScroll:true });
      });
      form.addEventListener('reset', () => {
        grid.replaceChildren();
        links.replaceChildren();
        results.hidden = true;
        status.textContent = 'Your choices have been cleared.';
        form.elements.interest.focus({ preventScroll:true });
      });
    });
  };
  window.ByardsGiftFinder = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
